export function parseLocalDate(dateStr: string): Date {
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day); // months are 0-indexed
}

function pad(n: number): string {
  return n.toString().padStart(2, '0');
}

function formatDateKey(date: Date): string {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

function formatDateToYYYYMMDD(date: Date): string {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export const humanizeDateRange = ({
  start,
  end,
}: {
  start: string;
  end: string;
}): string => {
  const startDate = parseLocalDate(start);
  const endDate = parseLocalDate(end);

  const startKey = formatDateKey(startDate);
  const endKey = formatDateKey(endDate);

  const sameDay = startKey === endKey;
  const sameMonth = startDate.getMonth() === endDate.getMonth();
  const sameYear = startDate.getFullYear() === endDate.getFullYear();

  const isFullYear =
    sameYear &&
    startKey === `${startDate.getFullYear()}-01-01` &&
    endKey === `${endDate.getFullYear()}-12-31`;

  const longMonth = new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
  const shortMonth = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
  });

  if (isFullYear) {
    return `${startDate.getFullYear()}`;
  }

  if (sameDay) {
    return longMonth.format(startDate);
  }

  // do check for same month and year and also if start and end dates represent start and end of month respectivelty
  if (
    sameMonth &&
    sameYear &&
    startDate.getDate() === 1 &&
    endDate.getDate() ===
      new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0).getDate()
  ) {
    return `${startDate.toLocaleString('en-US', {
      month: 'long',
    })} ${startDate.getFullYear()}`;
  }

  if (sameYear) {
    return `${shortMonth.format(startDate)} - ${shortMonth.format(endDate)}, ${startDate.getFullYear()}`;
  }

  return `${shortMonth.format(startDate)}, ${startDate.getFullYear()} - ${shortMonth.format(endDate)}, ${endDate.getFullYear()}`;
};
